import { render, staticRenderFns } from "./MultiselectList.vue?vue&type=template&id=1f64658d&scoped=true"
import script from "./MultiselectList.vue?vue&type=script&lang=js"
export * from "./MultiselectList.vue?vue&type=script&lang=js"
import style0 from "./MultiselectList.vue?vue&type=style&index=0&id=1f64658d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f64658d",
  null
  
)

export default component.exports